import {Component, ElementRef, ViewChild} from '@angular/core';
import {Router} from "@angular/router";
import {HttpClient} from "@angular/common/http";

import {LIST_SCROLL_INTERVAL, MENU_PAGE, WORD_SCROLL_SPEED} from '../shared/defines/desktop.const';
import {APP_VERSION} from "../shared/defines/client.const";
import {MP_RESULT} from "../shared/components/common-popups/msg-popup.component";
import {LayoutMgrService} from "../shared/services/layout-mgr/layout-mgr.service";
import {GlobalEventService} from "../shared/services/global-event/global-event.service";


const FILEPATH_LICENSES = 'assets/license/auto/licenses.json';

type License = {
  name: string;
  version?: string;
  licenses: string;
  repository?: string;
  publisher?: string;
  email?: string;
  url?: string;
  licenseFile?: string;
  licenseUrl?: string;
};

const listLicenseManual: Array<License> = [
  {
    name: '나눔명조',
    licenses: 'Open Font License, SIL Open Font License 1.1',
    publisher: '네이버와 네이버 문화재단',
    licenseUrl: 'https://help.naver.com/service/30016/contents/18088?osType=PC&lang=ko',
    url: 'https://hangeul.naver.com/fonts/search?f=nanum',
  },
  {
    name: 'Noto Sans Korea font',
    licenses: 'SIL Open Font License',
    licenseUrl: 'https://scripts.sil.org/cms/scripts/page.php?site_id=nrsi&id=OFL',
    url: 'https://fonts.google.com/noto/specimen/Noto+Sans+KR/about',
  },
  {
    name: 'Noto Serif Korea font',
    licenses: 'SIL Open Font License',
    licenseUrl: 'https://scripts.sil.org/cms/scripts/page.php?site_id=nrsi&id=OFL',
    url: 'https://fonts.google.com/noto/specimen/Noto+Serif+KR/about',
  },
  // {
  //   name: 'Hanazono font',
  //   publisher: 'GlyphWiki Project',
  //   licenses: 'Open Font License, SIL Open Font License 1.1',
  //   licenseFile: 'hanazono-LICENSE.txt',
  //   url: 'https://glyphwiki.org/hanazono/',
  //   repository: 'https://github.com/VdustR/hanamin',
  // },
  {
    name: 'Jigmo(字雲) font',
    publisher: '上地宏一',
    email: 'kamichi@ic.daito.ac.jp',
    licenses: 'CC0 1.0 Universal',
    licenseFile: 'jigmo-LICENSE.txt',
    url: 'https://kamichikoichi.github.io/jigmo/',
    repository: 'https://github.com/kamichikoichi/jigmo',
  },
  {
    name: 'SPICE',
    licenses: 'CC BY-NC 4.0',
    licenseUrl: 'https://creativecommons.org/licenses/by-nc/4.0/',
    url: 'https://www.kaggle.com/models/google/spice/tensorFlow1/spice',
  }
];  // 수동으로 만든 라이선스 목록


function replaceDoubleNewLinesWithBR(text: string): string {
  // 윈도우와 다른 OS 간 줄바꿈 문자 호환을 위해 모든 줄바꿈을 \n으로 통일
  const unifiedNewLinesText = text.replace(/\r\n/g, '\n');

  // 줄바꿈이 2개 연속되는 부분을 <br>로 변경
  // 여기서 \n\n은 연속된 두 줄바꿈을 의미하며, $&는 매치된 문자열(\n\n)을 참조합니다.
  const replacedText = unifiedNewLinesText.replace(/\n\n/g, '<br/><br/>');

  return replacedText;
}

/**
 * 파일 이름으로부터 확장자를 추출하고, 그것이 .md인지 확인하는 함수
 *
 * @param {string} fileName - 검사하고자 하는 파일의 이름
 * @returns {boolean} - 확장자가 .md이면 true, 그렇지 않으면 false를 반환
 */
function isMarkdown(fileName: string): boolean {
  // 파일 확장자 추출
  const extension = fileName.split('.').pop();

  // 확장자가 md인지 확인
  return extension?.toLowerCase() === 'md';
}

@Component({
  selector: 'app-open-source',
  templateUrl: './open-source.component.html',
  styleUrls: ['./open-source.component.scss']
})
export class OpenSourceComponent {
  @ViewChild('container') container?: ElementRef;
  @ViewChild('licenseContent', {static: true}) licenseContent?: ElementRef;
  protected readonly APP_VERSION = APP_VERSION;
  protected readonly MENU_PAGE = MENU_PAGE;

  listLicense: License[] = [];

  dataMarkdown: string | null = null;

  // 스크롤 처리
  private scrollDownInterval: any = null;

  constructor(
    private router: Router,
    private http: HttpClient,
    private globalEventSvc: GlobalEventService,
    protected lm: LayoutMgrService,
  ) {
    this.http.get<License[]>(FILEPATH_LICENSES).subscribe((data: License[]) => {
      const listLicense = data.map(license => {
        if (license.licenseFile) {
          // 'licenseFile'이 존재할 경우, 'auto/'를 앞에 추가합니다.
          license.licenseFile = 'auto/' + license.licenseFile;
        }
        return license;
      });
      this.listLicense = [...listLicense, ...listLicenseManual].sort((a: License, b: License) => {
        const nameVersionA = a.name + a.version;
        const nameVersionB = b.name + b.version;
        return nameVersionA.localeCompare(nameVersionB);
      });
      console.warn('listLicense:', this.listLicense);
    });
  }

  onClearData($event: MouseEvent) {
    $event.preventDefault();
    $event.stopPropagation();

    this.lm.OpenMsgPopup({
      title: '저장된 데이터 제거',
      msg: '저장된 데이터가 모두 사라집니다.',
      btnOk: '삭제',
      btnCancel: '취소',
    }).subscribe(data => {
      console.log(data);
      if (data === MP_RESULT.OK) {
        localStorage.clear();
      }
    });
  }

  onClickLicense($event: MouseEvent, license: License | null = null) {
    console.warn('onClickLicense:', license);
    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event);

    if (license?.licenseFile) {
      const licenseFile = 'assets/license/' + license.licenseFile;
      this.http.get(licenseFile, {responseType: 'text'}).subscribe((data: string) => {

        if (!isMarkdown(license.licenseFile!)) {
          data = replaceDoubleNewLinesWithBR(data);
        }
        this.dataMarkdown = data;

        this.licenseContent?.nativeElement.scrollTo({
          top: 0,
          behavior: 'smooth',
          // behavior: 'auto',
        });

        console.warn('srcMarkdown:', this.dataMarkdown);
      });
    }
    else {
      this.dataMarkdown = "";
    }
  }

  onClickRope($event: MouseEvent) {
    console.warn('onClickRope()', $event);
    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event, true);

    this.container?.nativeElement.scrollTo({
      top: 0,
      behavior: 'smooth',
      // behavior: 'auto',
    });

    this.licenseContent?.nativeElement.scrollTo({
      top: 0,
      behavior: 'smooth',
      // behavior: 'auto',
    });
  }

  onStartScrollDown($event: MouseEvent|TouchEvent) {
    // console.warn('onStartScrollDown()', $event, this.container?.nativeElement);
    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event);

    // 한번은 바로 내려간다.
    this.container?.nativeElement.scrollTo({
      top: this.container.nativeElement.scrollTop + WORD_SCROLL_SPEED * 2,
      behavior: 'auto',
    });

    this.scrollDownInterval = setInterval(() => {
      console.warn('scrollDownInterval', this.container?.nativeElement.scrollTop);

      this.container?.nativeElement.scrollTo({
        top: this.container.nativeElement.scrollTop + WORD_SCROLL_SPEED,
        behavior: 'auto',
      });
    }, LIST_SCROLL_INTERVAL);
  }

  onEndScrollDown($event: MouseEvent|TouchEvent) {
    // console.warn('onEndScrollDown()', $event);
    clearInterval(this.scrollDownInterval);
    this.scrollDownInterval = null;
  }

  onClickUrl($event: MouseEvent, licenseUrl: string) {
    $event.preventDefault();
    $event.stopPropagation();

    window.open(licenseUrl);
    return null;
  }
}
